import React from 'react'
import './placeabid.css'


function Place_a_bid(props){
     return(props.trigger) ? (
         <div className="place-a-bid-page">
             <div className="place-a-bid-section">
                 <button className="bid-closebtn" onClick={()=>props.setTrigger(false)}><i className="fas fa-times-circle"></i></button>
                 { props.children}
             </div>
         </div>
     ) : "" ;
 }

 export default Place_a_bid